module.exports = __webpack_public_path__ + "img/xinyue_gzh.b52c83a3.jpg";